import React from 'react';
import { useSelector } from 'react-redux';

import classes from './About.module.scss';

import RLogo from '../assets/About/react.svg';
import NLogo from '../assets/About/node.svg';
import JS from '../assets/About/javascript.svg';
import HLogo from '../assets/About/html.svg';
import Css from '../assets/About/css.svg';
import Sass from '../assets/About/sass.svg';
import Redux from '../assets/About/redux.svg';
import Figma from '../assets/About/figma.svg';
import Gimp from '../assets/About/gimp.svg'
import Inkscape from '../assets/About/inkscape.svg'

const About = () => {

    const darkMode = useSelector(state => state.darkMode)

    let mode = null;

    if(darkMode){
        mode = classes.InfoDark
    } else {
        mode = classes.InfoLight
    }

    return (
        //<div className={classes.Container}>
        <div className={classes.ScrollSnap} id='about'>  
            
            <div className={classes.Header}>
                <h1>About Me</h1>
            </div>
            <div className={mode}>
                <section>
                    <p>
                        Hi there! I am a passionate<em> Web Developer & Designer </em>with proficiency in javascript libraries like <em>React.js, Node.js, Redux, etc.</em> Along with a decent understanding of <em>UX/ UI design principles.</em> Also having hands on experience with design softwares like<em> figma, gimp, inkscape, etc.</em>
                    </p>
                </section>
                <section>
                    <p className={classes.Skills}>SKILLS :</p>
                    <div className={classes.ImgContainer}>
                        <img src={JS} alt="Js"/>
                        <img src={RLogo} alt="React"/>
                        <img src={NLogo} alt="Node"/>
                        <img src={Redux} alt="Redux"/>
                        <img src={HLogo} alt="Html"/>
                        <img src={Css} alt="Css"/>
                        <img src={Sass} alt="Sass"/>
                        <img src={Figma} alt="Figma"/>
                        <img src={Gimp} alt="Gimp"/>
                        <img src={Inkscape} alt="Inkscape"/>
                    </div>
                </section>
            </div>
            
        </div>
    )
}

export default About;